import {Component, OnInit} from '@angular/core';
import {LanguageService} from '@spartacus/core';
import {
  Configurator,
  ConfiguratorAttributeCheckBoxComponent,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorCommonsService,
} from '@spartacus/product-configurator/rulebased';
import {Observable} from 'rxjs';
import {DcpUiType} from '../../models';
import {ConfiguratorAddonService, StepInputService, UdexEventTypeService} from '../../services';
import {getComponentKey} from '../../utils';
import Attribute = Configurator.Attribute;
import UiType = Configurator.UiType;
import CustomUiTypeIndicator = Configurator.CustomUiTypeIndicator;

@Component({
  selector: 'dcp-configurator-attribute-addon-multi-value',
  templateUrl: './dcp-configurator-attribute-addon-multi-value.component.html',
  styleUrls: ['./dcp-configurator-attribute-addon-multi-value.component.scss'],
  standalone: false,
})
export class DcpConfiguratorAttributeAddonMultiValueComponent
  extends ConfiguratorAttributeCheckBoxComponent
  implements OnInit
{
  isAddOnChecked?: boolean;
  addOnLabel?: string;
  dropDownLabel?: string;
  alteredAttributeWithDifferentLabel: Configurator.Attribute = {name: ''};
  activeLanguage$: Observable<string> = this.languageService.getActive();
  addonAttributes$: Observable<Attribute[]> = this.configuratorAddonService.getFilteredAddonAttributes(
    this.attributeComponentContext,
  );
  readonly: boolean = false;

  constructor(
    protected configuratorAttributeCompositionContext: ConfiguratorAttributeCompositionContext,
    protected override configuratorCommonsService: ConfiguratorCommonsService,
    protected languageService: LanguageService,
    private configuratorAddonService: ConfiguratorAddonService,
    protected stepInputService: StepInputService,
    protected udexEventTypeService: UdexEventTypeService,
  ) {
    super(configuratorAttributeCompositionContext, configuratorCommonsService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.attribute.selectedSingleValue || this.attribute.userInput) {
      this.isAddOnChecked = true;
    }
    if (this.attribute.uiTypeVariation === UiType.RADIOBUTTON + CustomUiTypeIndicator + DcpUiType.READ_ONLY_ADDON) {
      this.attributeCheckBoxForm.disable();
      this.readonly = true;
    }
    this.setAddOnLabels();
  }

  onAttributeChange(): void {
    if (!this.readonly) {
      this.isAddOnChecked = !this.isAddOnChecked;
      this.attributeCheckBoxForm.patchValue(this.isAddOnChecked ? this.attribute?.values?.[0]?.valueCode : undefined);
      this.onCheckboxSelect();
    }
  }

  onCheckboxSelect() {
    if (!this.isAddOnChecked) {
      if (this.attribute.selectedSingleValue || this.attribute.userInput) {
        this.unselectDropdown();
      }
    } else {
      this.selectFirstDropdownValue();
    }
  }

  unselectDropdown(): void {
    this.configuratorCommonsService.updateConfiguration(this.ownerKey, {
      ...this.attribute,
      retractTriggered: true,
    });
  }

  selectFirstDropdownValue(): void {
    this.configuratorCommonsService.updateConfiguration(
      this.ownerKey,
      {
        ...this.attribute,
        selectedSingleValue: this.attribute.values?.[0].valueCode,
      },
      Configurator.UpdateType.ATTRIBUTE,
    );
  }

  setAddOnLabels() {
    [this.addOnLabel, this.dropDownLabel] = this.attribute?.label?.split(':').map((label) => label.trim()) ?? [];
    this.alteredAttributeWithDifferentLabel = {
      ...this.attribute,
      label: this.dropDownLabel ? this.dropDownLabel : this.addOnLabel,
    };
  }

  protected readonly getComponentKey = getComponentKey;
}
